<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-step-1">
          <div class="modal-header">
            <span class="modal-header-txt" v-if="!editMode">{{$t('add_a_new_expert')}}</span>
            <span class="modal-header-txt" v-if="editMode">{{$t('edit_expert')}}</span>
          </div>
          <div class="upload-image-main-div">
            <FileDrop :on-file-selected="onFileSelect" :selected-file="expertData.avatarUrl" />

            <div class="upload-image-div">
              <span class="header-span">{{$t('profile_photo')}}</span>
              <div class="upload-image-div">
                <span class="upload-image-txt">{{$t('explanation')}}</span>
                <span class="upload-image-txt">{{$t('recommended_format')}}</span>
              </div>
            </div>
          </div>
          <div class="forms">
            <div class="double-form">
              <div class="form-div">
                <span class="form-title">{{$t('name_expert')}} <span class="required-star">*</span></span>
                <input type="text" class="form-input" :class="{'input-error': errors.name}" v-model="expertData.name" :placeholder="$t('name_expert')" />
                <span v-if="errors.name" class="error-text">{{ errors.name }}</span>
              </div>
              <div class="form-div">
                <span class="form-title">{{$t('surname_person')}} <span class="required-star">*</span></span>
                <input type="text" class="form-input" :class="{'input-error': errors.surname}" v-model="expertData.surname" :placeholder="$t('surname_person')" />
                <span v-if="errors.surname" class="error-text">{{ errors.surname }}</span>
              </div>
            </div>

            <div class="form-div">
              <span class="form-title">{{$t('title_expert')}} <span class="required-star">*</span></span>
              <input type="text" class="form-input" :class="{'input-error': errors.title}" v-model="expertData.title" :placeholder="$t('title_expert')" />
              <span v-if="errors.title" class="error-text">{{ errors.title }}</span>
            </div>

            <div class="double-form">
              <div class="form-div">
                <span class="form-title">{{$t('email_address')}} <span class="required-star">*</span></span>
                <input type="text" class="form-input" :class="{'input-error': errors.email}" v-model="expertData.email" :placeholder="$t('email_address')" />
                <span v-if="errors.email" class="error-text">{{ errors.email }}</span>
              </div>
              <div class="form-div">
                <span class="form-title">{{$t('phone_number_person')}}</span>
                <input type="text" class="form-input" v-model="expertData.phoneNumber" :placeholder="this.$t('phone_number_person')" />
              </div>
            </div>

            <div class="double-form">
              <div class="form-div">
                <span class="form-title">{{$t('birthday')}}</span>
                <input type="date" class="form-input" v-model="birthdayDate" :placeholder="('birthday')" />
              </div>

              <div class="form-div">
                <span class="form-title">{{$t('experience')}}</span>
                <input
                    type="number"
                    class="form-input"
                    v-model.number="expertData.experiance"
                    :placeholder="$t('experience_years')"
                    min="0"
                    max="50"
                />
              </div>

              <!--<div class="form-div">
                  <span class="form-title">{{$t('type')}}</span>
                  <SelectBox :full-width="true" class="w-100" :options="expertTypes" :on-select="handleTypeSelect" :selected-value="expertData.type" :placeholder="$t('type')" />
                </div>
                -->
            </div>
            <div class="dropdown-wrapper mt-3">
              <span>{{$t('selected_language')}}</span>

              <multiselect
                  class="mt-3"
                  v-model="selectedLanguageCode"
                  :options="filteredLanguageOptions"
                  track-by="value"
                  label="text"
                  :multiple="true"
                  :placeholder="$t('selected_language')"
                  selectLabel=""
                  deselectLabel=""
                  selectedLabel=""
                  :internal-search="false"
                  @search-change="onLanguageSearch"
              >
                <template #noOptions>
                  <span class="no-data-found">{{$t('no_data_found')}}</span>
                </template>
              </multiselect>

            </div>
          </div>

          <div class="bottom-wrapper">
            <div class="btn-style" @click="onExpertAction">
              <span class="next-txt" v-if="!isLoading && !editMode">{{$t('add_expert')}}</span>
              <span class="next-txt" v-if="!isLoading && editMode">{{$t('save_button')}}</span>
              <VueSpinnerIos v-if="isLoading" size="20" height="100%" color="#fff" />
            </div>
          </div>
          <div @click="this.onHide" class="close-btn">
            <img class="cross" src="../../assets/images/cross.svg" />
          </div>
        </div>
      </div>
      <SuccessModal :is-visible="showSuccessModal" :on-close="onSuccessModalClose" />
    </div>
  </Transition>
</template>


<script>
import TextInput from "@/components/TextInput.vue";
import SelectBox from "@/components/SelectBox.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import FileDrop from "@/components/FileDrop.vue";
import expertService from "@/service/expertService";
import {
  VueSpinnerIos
} from 'vue3-spinners'
import {handleErrorResponse} from "@/utils/utils";
import languages from "@/lang/languages.json";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    FileDrop,
    SuccessModal,
    TextInput,
    SelectBox,
    VueSpinnerIos
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    expertId: {
      type: String,
      default: ""
    },
    editMode: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({
        name: "",
        surname: "",
        title: "",
        email: "",
        phoneNumber: "",
        birthday: "",
        avatarUrl: "",
        type: "",
        experiance: 0,
      })
    },
    refreshCallback: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false,
      isModalVisible: false,
      showSuccessModal: false,
      uploadedFile: null,
      birthdayDate: null,
      selectedLanguageCode: [],
      languageSearchQuery: '',
      errors: {
        name: '',
        surname: '',
        title: '',
        email: '',
      },
      expertData: {
        name: "",
        surname: "",
        title: "",
        email: "",
        phoneNumber: "",
        birthday: "",
        avatarUrl: "",
        type: "",
        experiance: 0,
      },
      /* expertTypes: [
        {
          value: 'expert',
          text: this.$t('expert_title')
        },
        {
          value: 'mentor',
          text: 'Mentor'
        },
        {
          value: 'authorized',
          text: this.$t('authorized')
        },
      ] */
    };
  },

  computed: {
    languageLists() {
        return languages[localStorage.getItem('userLanguage') || 'tr'];
    },
    filteredLanguageOptions() {
      if (!this.languageSearchQuery) {
        return this.languageLists;
      }
      const query = this.languageSearchQuery.toLocaleLowerCase('tr');
      return this.languageLists.filter(lang =>
        lang.text.toLocaleLowerCase('tr').includes(query)
      );
    }
  },

  methods: {
    onLanguageSearch(query) {
      this.languageSearchQuery = query;
    },
    showModal() {
      this.isModalVisible = true;
    },
    onSuccessModalClose() {
      this.showSuccessModal = false;
      this.resetForm();
    },
    onFileSelect(file) {
      this.uploadedFile = file;
    },
    onExpertAction() {
      if (this.editMode) {
        this.handleUpdateExpert();
      } else {
        this.handleAddExpert();
      }
    },

    validateForm() {
      this.errors = { name: '', surname: '', title: '', email: '' };
      let isValid = true;

      if (!this.expertData.name || !this.expertData.name.trim()) {
        this.errors.name = this.$t('expert_name_required');
        isValid = false;
      }
      if (!this.expertData.surname || !this.expertData.surname.trim()) {
        this.errors.surname = this.$t('expert_surname_required');
        isValid = false;
      }
      if (!this.expertData.title || !this.expertData.title.trim()) {
        this.errors.title = this.$t('expert_title_required');
        isValid = false;
      }
      if (!this.expertData.email || !this.expertData.email.trim()) {
        this.errors.email = this.$t('email_required');
        isValid = false;
      }

      if (!isValid) {
        this.$snackbar.add({ type: 'warning', text: this.$t('required_fields_warning') });
      }

      return isValid;
    },

    handleAddExpert() {
      if (!this.validateForm()) return;

      this.isLoading = true;

      const formData = new FormData();

      Object.entries(this.expertData).forEach(([key, value]) => {
        if (key !== 'languages') {
          formData.append(key, value);
        }
      });

      this.selectedLanguageCode.forEach(lang => formData.append('languages[]', lang.value));

      if (this.uploadedFile) {
        formData.append('avatar', this.uploadedFile);
      }

      expertService.addExpert(formData).then((response) => {
        this.showSuccessModal = true;
        this.isLoading = false;
        this.refreshCallback();
      }).catch((error) => {
        this.isLoading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },

    handleUpdateExpert() {
      if (!this.validateForm()) return;

      this.isLoading = true;

      const formData = new FormData();

      Object.entries(this.expertData).forEach(([key, value]) => {
        if (key !== 'languages') {
          formData.append(key, value);
        }
      });

      this.selectedLanguageCode.forEach(lang => formData.append('languages[]', lang.value));

      if (this.uploadedFile) {
        formData.append('avatar', this.uploadedFile);
      }

      formData.append('expertId', this.expertId);

      expertService.updateExpert(formData).then((response) => {
        this.isLoading = false;
        this.refreshCallback();

        this.$snackbar.add({
          type: 'success',
          text: this.$t('expert_updated_successfully')
        });
      }).catch((error) => {
        this.isLoading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },

    convertYMDToDmy(dateString) {
      const dateObject = new Date(dateString);

      const day = String(dateObject.getDate()).padStart(2, '0');
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const year = dateObject.getFullYear();

      return `${day}.${month}.${year}`;
    },
    convertDate(date) {
      const dateObject = new Date(date);
      const year = dateObject.getUTCFullYear();
      const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, '0');
      const day = dateObject.getUTCDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    handleTypeSelect(value) {
      this.expertData.type = value;
    },
    resetForm() {
      this.expertData = {
        name: "",
        surname: "",
        title: "",
        email: "",
        phoneNumber: "",
        birthday: "",
        avatarUrl: "",
        type: "",
        experiance: 0,
      };
      this.errors = { name: '', surname: '', title: '', email: '' };
      this.birthdayDate = null;
      this.uploadedFile = null;
    }
  },

  watch: {
    editData: {
      handler() {
        if (this.editMode) {
          this.expertData = {
            name: this.editData.name,
            surname: this.editData.surname,
            title: this.editData.title,
            email: this.editData.email,
            phoneNumber: this.editData.phone,
            birthday: this.editData.birthday,
            avatarUrl: this.editData.avatarUrl,
            type: this.editData.type,
            experiance: this.editData.experiance || 0,
          }
          this.selectedLanguageCode = this.editData.languages.map(lang => {
            return languages[localStorage.getItem('userLanguage') || 'tr'].find(l => l.value === lang);
          }) || [];
          this.birthdayDate = this.convertDate(this.editData.birthday);
        }
      },
      deep: true,
    },
    birthdayDate: {
      handler() {
        this.expertData.birthday = this.convertYMDToDmy(this.birthdayDate);
      }
    }
  },
};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}

.cross {
  padding: 8px;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}

.modal-header-txt {
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}

.upload-image-main-div {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 24px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  height: auto;
}

.upload-image-div {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
}

.header-span {
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 16px;
  line-height: 24px;
}

.upload-image-txt {
  color: #667085;
  font-size: 14px;
  line-height: 20px;
}

.forms {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  align-items: flex-start;
  width: 100%;
}

.double-form {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
}

.form-div {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  z-index: 2;
}

.form-div.half {
  width: calc(50% - 12px);
}

.form-title {
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.dropdown-wrapper{
  width: 100%;
}

.btn-style {
  display: flex;
  border-radius: 24px;
  background: #040C2D;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 48px;
  cursor: pointer;
}

.next-txt {
  font-family: euclid_medium, sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.bottom-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  flex: 1
}

.required-star {
  color: #F04438;
}

.error-text {
  color: #F04438;
  font-size: 12px;
  line-height: 16px;
  margin-top: -4px;
}

.input-error {
  border: 1px solid #F04438 !important;
}

@media (max-width: 678px) {
  .upload-image-main-div {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
